var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":_vm.query,"variables":_vm.variables,"fetch-policy":_vm.fetchPolicy},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
return [_c('Loading',{attrs:{"active":isLoading > 0}}),(error)?_c('span',[_vm._v(_vm._s(_vm.$t('common.errors.apollo_error', {error: error})))]):(data)?_c('span',[_vm._t("default",null,{"data":data})],2):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }